module.exports = __webpack_public_path__ + "static/media/The Bold and Brave.862a2064.jpg";